<template lang="pug">
#calendar
  section.section.page-section.container.is-fluid
    spinner(v-if="settings.loading")
    .empty-calendar.has-text-centered(
      v-else-if="months.length === 0"
    )
      b-icon(icon="calendar-remove" size="is-large")
      h3.is-size-3 There are no upcoming events
      p.is-size-4.has-text-grey-light Please check back soon
    .months(v-else)
      .month(
        v-for="month in months"
        :key="month.id"
      )
        .mobile-padding
          h3.month-heading.is-size-4 {{ month.month | date('MMMM', true) }}
        .events.columns.is-multiline
          .column.is-one-third-desktop.is-one-third-widescreen(
            v-for="event in month.events"
            :key="event.id"
          )
            event-list-item(
              :value="event"
              :hoverable="false"
              :limit="2"
              :month="month.month"
              type="thumbnail"
            )
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import EventDate from '@/components/events/EventDate.vue';
import EventListItem from '@/components/events/EventListItem.vue';
import ServiceTimes from '@/components/ServiceTimes.vue';
import Spinner from '@/components/Spinner.vue';
import ThisWeek from '@/components/events/ThisWeek.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'calendar-page',
  created() {
    this.getPage(this.pagination.page);
  },
  components: {
    EventDate,
    EventListItem,
    ServiceTimes,
    Spinner,
    ThisWeek,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      page: getterTypes.GET_PAGE,
    }),
    esQuery() {
      const today = moment().format('YYYY-MM-DD');
      const payload = {
        aggs: {
          by_month: {
            terms: {
              field: 'months',
              size: 12,
              order: { _key: 'asc' },
            },
            aggs: {
              events: {
                top_hits: {
                  size: 12,
                  sort: [
                    { end_date: 'asc' },
                    { 'title.raw': 'asc' },
                    '_score',
                  ],
                },
              },
            },
          },
        },
        size: 0,
        sort: [
          { end_date: 'asc' },
          { 'title.raw': 'asc' },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { match: { type: 'event' } },
              { range: { pub_date: { lte: today } } },
              { range: { end_date: { gte: today } } },
            ],
          },
        },
      };
      return payload;
    },
  },
  data() {
    return {
      ministries: [],
      months: [],
      pagination: {
        page: 1,
        per: 20,
        total: 0,
      },
      settings: {
        loading: true,
      },
    };
  },
  methods: {
    async getPage() {
      this.settings.loading = true;
      const { data } = await SEARCH.post('/doxa_events/event/_search', this.esQuery);
      const { buckets } = data.aggregations.by_month;
      if (buckets.length > 0) {
        buckets.forEach((bucket) => {
          const events = _.filter(bucket.events.hits.hits, (hit) => {
            const event = hit._source;
            const bom = moment(bucket.key_as_string, 'YYYY-MM-DD').startOf('month');
            const eom = moment(bucket.key_as_string, 'YYYY-MM-DD').endOf('month');
            const filteredDates = _.filter(event.dates, (str) => {
              const date = moment(str, 'YYYY-MM-DD');
              return date.isBetween(bom, eom, 'day', '[]') && date.isSameOrAfter(moment(), 'day');
            });
            return filteredDates.length > 0;
          });
          if (events.length > 0) {
            this.months.push({
              month: bucket.key_as_string,
              events: this.sortEvents(_.map(events, '_source'), bucket.key_as_string),
            });
          }
        });
      }
      this.settings.loading = false;
    },
    sortEvents(events, month) {
      const bom = moment(month, 'YYYY-MM-DD').startOf('month');
      const eom = moment(month, 'YYYY-MM-DD').endOf('month');
      return _.sortBy(events, (e) => {
        const thisMonth = _.filter(e.dates, (d) => {
          const date = moment(d, 'YYYY-MM-DD');
          return date.isBetween(bom, eom, 'day', '[]');
        });
        return _.min(thisMonth);
      });
    },
  },
};
</script>

<style lang="scss">
#calendar {
  .empty-calendar {
    padding-top: 8rem;
    h3 {
      margin: 0.65rem 0 0.5rem 0;
    }
  }
  .months {
    .month-heading {
      margin-bottom: 0.75rem;
    }
    .month {
      margin-bottom: 1.75rem;
      .events {

      }
    }
  }
}

@media (max-width: $tablet) {
  #calendar {
    .page-section {
      padding-top: 0.5rem;
    }
    .months {
      .month {
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
